<template>
  <div>
    <div class="line">
      <el-radio label="0" v-model="type" @change="update">
        <span>指定活动</span>
        <el-select v-model="activityType" @change="handleChange" multiple style="margin-left: 24px;">
          <el-option value="" label="不限"></el-option>
          <el-option v-for="item in options" :key="item.value" :value="item.value" :label="item.label"></el-option>
        </el-select>
        <el-select v-if="activityType[0] != ''" v-model="activityId" @change="handleChange2" multiple
          style="margin-left:8px">
          <el-option value="" label="不限"></el-option>
          <el-option v-for="item in childOptions" :key="item.id" :value="item.interactActivityId" :label="item.activityName"></el-option>
        </el-select>
      </el-radio>
    </div>
    <div class="line">
      <el-radio label="1" v-model="type" @change="update">
        <span>指定活动ID</span>
        <el-input v-model="activityIds" @input="update" placeholder="多个ID用英文逗号隔开" style="margin-left: 10px;width: 380px;"></el-input>
      </el-radio>
    </div>
  </div>
</template>

<script>
import { getActivityList } from '@/api/public.js';
export default {
  name: '',
  components: {},
  props: {
    options: {
      type: Array
    },
    form: {
      type: Object,
      default: () => {
        return {
          mode: '0',
          activityTypes: [''],
          interactActivityIds: [""],
          activityId: "",
        }
      }
    }
  },
  data() {
    return {
      activityType: [""],
      activityId: [""],
      childOptions: [],
      type: "0",
      activityIds: ""
    }
  },
  computed: {},
  created() {
    console.log(this.form, '=========>');
  },
  mounted() {
    this.type = this.form.mode || "0"
    if (this.form.mode == "0") {
      this.activityType = this.form.activityTypes.length == 0 ? [""] : this.form.activityTypes;
      getActivityList({ multipleActivityType: this.activityType.join(",") }).then(res => {
        this.childOptions = res.data;
        this.activityId = this.form.interactActivityIds.length == 0 ? [""] : this.form.interactActivityIds;
      })
    }else{
      this.activityIds = this.form.activityId;
    }
  },
  methods: {
    handleChange(val) {
      this.activityId = [""];
      if (val.length !== 1 && val.includes("")) {
        // 点击全选 则清空其他选项
        if (val[val.length - 1] === "") {
          this.activityType = [""];
        } else {
          // 点击其他选项 则过滤空值
          this.activityType = val.filter((item) => item !== "");
        }
      } else if (val.length == 0) {
        this.activityType = [""]
      }
      this.$emit('update:form', { ...this.form, activityTypes: this.activityType, interactActivityIds: this.activityId, activityId: this.activityIds,mode: this.type })
      if (this.activityType[0] != "") {
        let param = {
          activityType: "",
          multipleActivityType: this.activityType.join(",")
        }
        getActivityList(param).then(res => {
          this.childOptions = res.data;
        })
      }
    },
    handleChange2(val) {
      if (val.length !== 1 && val.includes("")) {
        // 点击全选 则清空其他选项
        if (val[val.length - 1] === "") {
          this.activityId = [""];
        } else {
          // 点击其他选项 则过滤空值
          this.activityId = val.filter((item) => item !== "");
        }
      } else if (val.length == 0) {
        this.activityId = [""]
      }
      this.$emit('update:form', { ...this.form, activityTypes: this.activityType, interactActivityIds: this.activityId, activityId: this.activityIds,mode: this.type })
      console.log(this.form);
    },
    update(){
      this.$emit('update:form', { ...this.form, activityTypes: this.activityType, interactActivityIds: this.activityId, activityId: this.activityIds,mode: this.type })
    },
  }
}
</script>
<style lang='scss' scoped>
.line {
  line-height: 45px;
}

:deep(.el-select__tags > span) {
  height: 24px;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
}

:deep(.el-select__tags .el-tag--info:not(:last-child)::after) {
  content: ",";
}

:deep(.el-tag__close) {
  display: none;
}

:deep(.el-select__tags .el-tag--info) {
  background-color: transparent;
  padding-left: 0;
  padding-right: 0;
  border-color: #fff;

  .el-select__tags-text {
    max-width: none !important;
    color: #606266;
    font-size: 14px;
  }
}
</style>